module.exports = __webpack_public_path__ + "media/student_finance/financial-aid-303531b4.png";